import axios from "axios";
import constants from "../../utils/constants";

const PARAMETERS_BASE_URL = "/api/parameters";

export const searchContentByType = contentType => {
  const url = `${constants.BASE_URL}${PARAMETERS_BASE_URL}/contents/by-type`;
  const config = { withCredentials: true, params: { tipo: contentType } };
  return axios.get(url, config);
};

export const saveContent = data => {
  const url = `${constants.BASE_URL}${PARAMETERS_BASE_URL}/contents`;
  const config = { withCredentials: true };
  return axios.post(url, data, config);
};
